import { auth } from "@/firebase/config";

export const login = async (mail, password) => {
    try {
        await auth
            .signInWithEmailAndPassword(mail, password);
        return null;
    } catch (error) {
        return error;
    }
};

export const signup = async (mail, password) => {
    try {
        await auth
            .createUserWithEmailAndPassword(mail, password);
        return null;
    } catch (error) {
        return error;
    }
}

export const logout = () => {
    auth.signOut();
}
